const qrShowBtn = document.querySelector('.show-qr-code-img');
const qrCodeImg = document.querySelector('.qr-code-img');

qrShowBtn?.addEventListener('click', (e) => {
    e.preventDefault();

    qrCodeImg.classList.toggle('show');
});
